export function getSessionIdCookie() {
  const matches = document?.cookie?.match(/[; ]session_id=([^\\s;]*)/);

  if (matches) {
    return matches[1];
  }

  return undefined;
}
